import React, {useLayoutEffect, useRef, useState} from "react";
import * as styles from "./MoreLess.module.css";
import {Button} from "antd";

const MAX_HEIGHT = 160;

interface Props {
    children?: React.ReactNode;
    textMore?: string;
    textLess?: string;
}

function MoreLess(props: Props) {
    const divRef = useRef<HTMLDivElement>(null);
    const previouslyExceededRef = useRef(false);
    const [hidden, setHidden] = useState(false);
    const [heightExceeded, setHeightExceeded] = useState(false);

    useLayoutEffect(() => {
        const height = divRef.current?.scrollHeight ?? 0;
        const exceeded = height > MAX_HEIGHT;

        setHeightExceeded(exceeded);

        if (!exceeded) {
            setHidden(false);
        } else if (!previouslyExceededRef.current) {
            // Newly overflowing content starts collapsed, but preserve manual expand/collapse afterwards.
            setHidden(true);
        }

        previouslyExceededRef.current = exceeded;
    }, [props.children]);

    return (
        <div
            ref={divRef}
            className={`${styles['outer-box']} ${hidden ? styles['outer-box-less'] : ''}`}
            style={{["--more-less-max-height" as string]: `${MAX_HEIGHT}px`}}
        >
            <div className={styles['inner-box']}>
                {props.children}
            </div>

            {heightExceeded && <div className={styles["more-less-button-wrapper"]}>
                <Button className={styles['more-less-button']} size={"small"} type={"link"} onClick={() => setHidden(prevValue => !prevValue)}>
                    {hidden && (props.textMore || 'show more')}
                    {!hidden && (props.textLess || 'show less')}
                </Button>
            </div>}
        </div>
    );
}

export default MoreLess;
